import { dayjs } from '@/api/utils/dayjs'

export function getMoonEventLink(path: string, at?: string) {
  return at
    ? `${path}?at=${encodeURIComponent(at)}`
    : path
}

export function getMoonReferenceAt(search: string) {
  return new URLSearchParams(search).get('at') ?? undefined
}

export function getMoonQuestionContext(
  at: string | undefined,
  fallbackAt: string,
  title: string,
) {
  const requestedDate = at ? dayjs(at) : undefined
  const periodDate = (requestedDate?.isValid() ? requestedDate : dayjs(fallbackAt))
    .startOf('day')
  const today = dayjs().startOf('day')
  const periodLabel = periodDate.isAfter(today)
    ? 'Вопрос о будущем периоде: '
    : periodDate.isBefore(today)
      ? 'Вопрос о прошлом периоде: '
      : ''

  return `${periodLabel}${periodDate.format('D MMMM YYYY')}, ${title}.`
}
